<div class="page center">
  <img src="/assets/icons/special/time-circle.svg" alt="" />
  <h1>Scheduled Maintenance</h1>
  <p class="standard-text">We’re currently undergoing some planned maintenance. We’ll be back soon!</p>
  <p class="standard-text legal"><b>Note:</b> This page will refresh automatically when we’re back.</p>
</div>
